'use strict';
module.exports = require('./Tooltip.js');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/tooltip/index.js
// module id = 84
// module chunks = 1